import { useEffect } from 'react'

import { useTrackerClient } from '../../TrackerClientProvider.js'

import { ActorAnalyticsContext, TargetAnalyticsContext } from './snowplow.js'

interface UseAnalyticsProps {
  actor?: Partial<ActorAnalyticsContext>
  target?: Partial<TargetAnalyticsContext>
}

export const useAnalytics = ({ actor, target }: UseAnalyticsProps = {}) => {
  const { tracker, unsetTracker } = useTrackerClient()

  useEffect(() => {
    if (!tracker) {
      return null
    }

    tracker.setActor(actor)
    tracker.setTarget(target)

    return () => {
      unsetTracker({ actor, target })
    }
  }, [tracker, actor, target, unsetTracker])

  return tracker
}
